import React from 'react';
import { InteractionTag, InteractionTagPrimary, TagGroup } from '@fluentui/react-components';
import { ChevronRightRegular } from '@fluentui/react-icons';
import { Text } from '../Text';
import { SearchSuggestionsProps } from './Search.interface';
import './Search.css';

/* eslint-disable-next-line @typescript-eslint/ban-types */
export const SearchSuggestions = <RecordType extends Object>({
  label,
  suggestions,
  handleSuggestionClick,
}: SearchSuggestionsProps<RecordType>) => {
  return (
    <div className="flex items-center">
      <Text weight="bold">{label + ':'}</Text>
      <TagGroup aria-label={label}>
        {suggestions.map((result, index) => (
          <InteractionTag
            // aix-tag-grey: Fluent fills a tag with the same color as the page surface
            // (--page-bg-color), which would make the suggestion invisible.
            className="searchSuggestionPill aix-tag-grey"
            size="small"
            key={index}
            onClick={() => {
              handleSuggestionClick(result.result);
            }}
          >
            <InteractionTagPrimary
              icon={<ChevronRightRegular />}
            >
              {result.result}
            </InteractionTagPrimary>
          </InteractionTag>
        ))}
      </TagGroup>
    </div>
  );
};
